module.exports = __webpack_public_path__ + "img/tu02.76fc5569.jpg";